// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"Video_playerWrapper__9z3uk","reactPlayer":"Video_reactPlayer__3g8lK"};